import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/Gift.svg'

export const IconGift = IconSVG as IconComponent
